import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { CalendarDays, ChevronDown, ChevronUp } from 'lucide-react';
import { fmtDate } from '../shared';

export const BilanChrono = ({ chronologie }) => {
  const [open, setOpen] = useState(true);
  return (
    <Card className="border-0 shadow-sm" data-testid="bilan-chrono">
      <CardHeader className="pb-2 flex-row items-center justify-between">
        <CardTitle className="text-base flex items-center gap-2"><CalendarDays className="w-4 h-4 text-indigo-500" /> Fil chronologique ({chronologie.length} séance(s))</CardTitle>
        <button type="button" onClick={() => setOpen(o => !o)} className="text-xs text-slate-500 flex items-center gap-1" data-testid="bilan-chrono-toggle">{open ? <><ChevronUp className="w-3.5 h-3.5" /> Replier</> : <><ChevronDown className="w-3.5 h-3.5" /> Déplier</>}</button>
      </CardHeader>
      {open && (
        <CardContent className="p-0">
          {chronologie.length === 0 && <p className="text-slate-400 text-xs px-4 pb-4">Aucune séance réalisée à cette date.</p>}
          <div className="divide-y">
            {chronologie.map(j => (
              <div key={`${j.date}-${j.via_aft || 'af'}`} className={`px-4 py-2.5 text-xs grid grid-cols-1 md:grid-cols-[110px_1fr_2fr] gap-2 ${j.via_aft ? 'bg-cyan-50/40' : ''}`} data-testid={`bilan-chrono-${j.date}${j.via_aft ? `-${j.via_aft}` : ''}`}>
                <div>
                  <p className="font-semibold text-slate-800">{fmtDate(j.date)}</p>
                  {j.via_aft && <p className="text-[10px] font-semibold text-cyan-700" data-testid={`bilan-chrono-via-aft-${j.date}`}>Session d'examen {j.via_aft}</p>}
                  <p className="text-slate-400">{j.formateur || '—'}</p>
                  <p className={`mt-0.5 ${j.presences_validees ? 'text-emerald-600' : 'text-amber-600'}`}>{j.presents + j.retards}/{j.presents + j.retards + j.absents} prés.{j.presences_validees ? '' : ' (non validées)'}</p>
                </div>
                <div className="space-y-0.5">
                  {j.modules.map((m, i) => <p key={i} className="text-slate-700"><span className="font-mono text-[10px] text-slate-400 mr-1">{m.code}</span>{m.titre}</p>)}
                  {j.modules.length === 0 && <p className="text-slate-400">Aucun module renseigné</p>}
                  {j.evaluations.map((e, i) => <p key={i} className="text-violet-700">{e.type} · {e.titre} — <b>{e.moyenne}%</b> ({e.nb})</p>)}
                </div>
                <div className="space-y-0.5 text-slate-600">
                  {j.deroule && <p><span className="font-semibold text-slate-500">Déroulé :</span> {j.deroule}</p>}
                  {j.exercices && <p><span className="font-semibold text-slate-500">Exercices :</span> {j.exercices}</p>}
                  {j.cas_pratique && <p><span className="font-semibold text-slate-500">Cas pratique :</span> {j.cas_pratique}</p>}
                  {!j.deroule && !j.exercices && !j.cas_pratique && <p className="text-slate-300">Déroulé non renseigné</p>}
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      )}
    </Card>
  );
};
